<template>
  <div class="charts-section">
    <div v-for="entry in projectsSdgData" :key="entry.data.text" class="chart-block">
      <label class="count">
        {{ entry.data.selected }}
        <span class="all">/ {{ entry.data.all }}</span>
      </label>
      <div class="chart-wrap">
        <div
          class="bar visible-part"
          :style="{backgroundColor: entry.options.visible.backgroundColor, width: `${entry.options.visible.barWidth}px`}"
        />
        <div
          class="bar invisible-part"
          :style="{backgroundColor: entry.options.invisible.backgroundColor, width: `${entry.options.invisible.barWidth}px`}"
        />
      </div>
      <label class="sdg-title" :title="entry.data.label">{{ entry.data.label }}</label>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import numbro from 'numbro'
import optionsData from '@/data/options'

const currencyFormat = {
  average: true,
  mantissa: 2,
  optionalMantissa: true,
  currencyPosition: 'prefix',
}

const chartWidth = 175

export default {
  name: 'charts-section',
  computed: {
    ...mapGetters({
      inBoundsProjectsSdg: 'projects/inBoundsProjectsSdg',
      allProjectsSdg: 'projects/allProjectsSdg',
      budgetsPerSdg: 'projects/budgetsPerSdg',
      selectedSdg: 'companies/selectedSdg',
    }),
    sdgOptions() {
      return optionsData.sdgOptions.filter(
        item => !!item.isFocusArea || this.selectedSdg.includes(item.code)
      )
    },
    projectsSdgData() {
      const maxSdgCount = Math.max.apply(
        Math,
        Object.keys(this.budgetsPerSdg).map(
          key => this.budgetsPerSdg[key].total
        )
      )
      const sdgArr = Object.entries(this.allProjectsSdg)
      const res = sdgArr.map(sdg => {
        const code = sdg[0]
        const unfilteredValue = this.budgetsPerSdg[code].total || 0
        const filteredValue = this.budgetsPerSdg[code].visible || 0
        const sdgOption = this.sdgOptions.find(option => option.code === code)

        if (!sdgOption) {
          return null
        }

        const totalCount = unfilteredValue
        const visibleCount = filteredValue
        const invisibleCount = totalCount - visibleCount

        const options = {
          visible: {
            barWidth: (chartWidth * visibleCount) / maxSdgCount,
            backgroundColor: sdgOption.color,
            hoverBorderWidth: 0,
          },
          invisible: {
            barWidth: (chartWidth * invisibleCount) / maxSdgCount,
            backgroundColor: sdgOption.lighterColor,
            hoverBorderWidth: 0,
          },
        }

        const data = {
          all: this.formatToCurrency(unfilteredValue),
          selected: this.formatToCurrency(filteredValue),
          label: sdgOption.text,
        }

        return {
          options,
          data,
        }
      })
      return res.filter(result => result)
    },
  },
  methods: {
    formatToCurrency(v) {
      return `$${numbro(v).format(currencyFormat)}`
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-block {
  display: flex;
  label {
    display: inline-block;
    font-size: 10px;
    white-space: nowrap;
    text-align: left;
    .all {
      color: #8f949a;
    }
  }
  .count {
    min-width: 100px;
    display: block;
    text-align: right;
  }
}
.charts-section {
  padding: 10px 34px;
}
.chart-wrap {
  display: flex;
  width: 175px;
  padding-top: 5px;
  margin: 0 10px;

  .bar {
    height: 4px;
    display: inline-block;
    transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
  }
}
.sdg-title {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100px;
}
</style>
